import { GlAccountSummary, glAccountSummaryFromApiResponse } from "../../types/GlAccountSummary";
import type {VatCode} from '../../generated/enums.ts';

export class BaseTransaction {
    public id: string;
    public counterParty: string;
    public iban: string;
    public relationName: string;
    public desc: string;
    public date: string;
    public flow: string;
    public amount: number;
    public accountId: string;
    public raw: string;
    public generalLedgerAccountId: string | null;
    public generalLedgerAccount: GlAccountSummary;
    public reconciliationId: string | null;
    public vatCode: VatCode | null;

    constructor(
        id: string,
        counterParty: string,
        iban: string,
        relationName: string,
        desc: string,
        flow: string,
        amount: number,
        date: string,
        raw: string,
        accountId: string,
        generalLedgerAccountId: string | null,
        generalLedgerAccount: GlAccountSummary,
        reconciliationId: string | null,
        vatCode: VatCode | null,
    ) {
        this.id = id
        this.counterParty = counterParty
        this.iban = iban
        this.relationName = relationName
        this.desc = desc
        this.date = date
        this.flow = flow
        this.amount = amount
        this.raw = raw
        this.accountId = accountId
        this.generalLedgerAccountId = generalLedgerAccountId
        this.generalLedgerAccount = generalLedgerAccount
        this.reconciliationId = reconciliationId
        this.vatCode = vatCode
    }

    get value(): number {
        if (this.flow === 'inflow') {
            return this.amount
        } else {
            return -this.amount
        }
    }

    public book(glAccountId: string | null, generalLedgerAccount: GlAccountSummary): this {
        this.generalLedgerAccountId = glAccountId
        this.generalLedgerAccount = generalLedgerAccount
        return this
    }


    public static fromApiResponse(data: Record<string, unknown>): BaseTransaction {
        return new BaseTransaction(
            data['transaction_id'] as string,
            data['relation_name'] as string,
            data['relation_iban'] as string,
            data['relation_name'] as string,
            data['desc'] as string,
            data['flow'] as string,
            parseFloat(String(data['amount'])),
            data['booking_date'] as string,
            data['raw'] as string,
            data['account_id'] as string,
            data['general_ledger_account_id'] as string | null,
            glAccountSummaryFromApiResponse(data['general_ledger_account'] as Record<string, unknown>),
            (data['reconciliation_id'] as string | null) ?? null,
            (data['vat_code'] as VatCode | null) ?? null,
        )
    }
}
